// extracted by mini-css-extract-plugin
export default {"root":"_3dNxZ","content-root":"_24uyD","contentRoot":"_24uyD"};